import { Component, Inject, Renderer2 } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Constants } from '../../common/constants';
import { DOCUMENT } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';
@Component({
  selector: 'app-cybersecurity-blog',
  templateUrl: './cybersecurity-blog.component.html',
  styleUrls: ['./cybersecurity-blog.component.css']
})
export class CybersecurityBlogComponent {
  constructor(
    private titleService: Title,private seoService:SeoService,
    private metaService: Meta, private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
  ) {}

  baseUrl = Constants.baseUrl;

  ngOnInit(): void {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/cyber-security/"
  },
  "headline": "Importance of Cybersecurity in Business Growth",
  "description": "Generally, we do think that large-sized businesses are the most affected due to cyber-attacks, but on the contrary small businesses are the ones who are affected.",
  "image": "",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT Resources",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2022-11-11"
}`;
   
    this._renderer2.appendChild(this._document.head, script);
    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();
  }

  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Importance of Cybersecurity in Business Growth');

    this.metaService.addTags([
      { name: 'description', content: 'Generally, we do think that large-sized businesses are the most affected due to cyber-attacks, but on the contrary small businesses are the ones who are affected!' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Importance of Cybersecurity in Business Growth' },
      { property: 'og:url', content: 'https://mitresource.com/cyber-security/' },
      { property: 'og:image', content: '' }, // Add an image URL if available
      { property: 'og:description', content: 'Generally, we do think that large-sized businesses are the most affected due to cyber-attacks, but on the contrary small businesses are the ones who are affected.' },
    ]);
  }
}
